import React, { Component } from 'react';

import { Form, Layout, Button, Row, Col, Icon, Upload, message, Modal, DatePicker } from 'antd';

const { Header, Content, Footer } = Layout;

import service from './../services';

import LicenseForm from './LicenseForm';
import LicenseForm2 from './LicenseForm2';

class License extends Component {
    constructor(props) {
        super(props);

        this.state = {
        }
    }

    componentDidMount() {
        service.license.getStatus()
            .then(response => {
                if (response.code == 200) {
                    message.info(`${response.message}`)
                }
            })
    }

    render() {
        return (
            <Layout>
                <Header style={{ position: 'fixed', zIndex: 1, width: '100%', height: '64px' }}>
                </Header>
                <Content className='license-content' style={{ marginTop: 64 }}>
                    <h2 style={{ textAlign: 'center', marginTop: 15 }}>
                        <img style={{ width: 40, height: 40, marginRight: 5 }} src={`./logo.png`} />
                        教学质量管理与诊断分析平台许可证注册</h2>
                    <div className='license-content-container'>
                        <LicenseForm></LicenseForm>
                        <LicenseForm2></LicenseForm2>
                    </div>
                </Content>
                <Footer style={{ textAlign: 'center', height: '64px' }}>教学质量管理与诊断分析平台 ©2024 Created by lihusoft</Footer>
            </Layout>
        );
    }
}

export default Form.create()(License);